import { render, staticRenderFns } from "./PackageSteps.vue?vue&type=template&id=7bc0d084&scoped=true&"
import script from "./PackageSteps.vue?vue&type=script&lang=js&"
export * from "./PackageSteps.vue?vue&type=script&lang=js&"
import style0 from "./PackageSteps.vue?vue&type=style&index=0&id=7bc0d084&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bc0d084",
  null
  
)

export default component.exports